import { cloudChiprApi } from "../../../../../services/cloudchipr.api";

export const resourceExplorerProviderByProviderPossibleFiltersSelector =
  cloudChiprApi.endpoints
    .getUsersMeOrganisationsCurrentResourceExplorerProvidersByProviderFilters
    .select;
